<template>
  <section :class="$style.sectionRoot">
    <header :class="$style.sectionHeader">
      Details
    </header>
    <div :class="$style.sectionContent">
      <div :class="$style.inputRow">
        <InputValidator
          :class="$style.flexSingleWidth"
          :config="{
            attribute: 'name',
            label: 'Name',
            name: 'name',
            validate: 'required',
            value: item.name,
          }"
          @InputValidatorModel="handleFieldChange"
        />
      </div>
      <div :class="[$style.inputRow, $style.inputRowCentered]">
        <div :class="$style.flexSingleWidth">
          <label
            :class="[
              $style.label,
              $style['label-position'],
              $style['label-font'],
              $style['label-color'],
              $style['label-typography'],
            ]"
          >
            Type
          </label>
          <div :class="$style.commandTypePillContainer">
            <Pill
              v-for="commandType in commandTypeOptions"
              :key="commandType"
              :active="commandType === item.commandType"
              :interactive="true"
              :text="capitalize(commandType)"
              @click="handleFieldChange(commandType, 'commandType')"
            />
          </div>
        </div>
        <Checkbox
          v-show="item.commandType === commandTypes.windows"
          :class="$style.flexSingleWidth"
          label="Windows Powershell"
          name="shell"
          :value="item.shell === 'powershell'"
          @input="checked => handleFieldChange(checked ? 'powershell' : 'cmd', 'shell')"
        />
      </div>
      <div :class="$style.inputRow">
        <CopyWell
          :class="$style.copyWell"
          :inlineLabel="false"
          :isEditable="true"
          label="Command"
          :multiLine="true"
          name="command"
          :placeholder="commandPlaceholder[item.commandType] || ''"
          rules="required"
          :value="item.command"
          @input="(value) => handleFieldChange(value, 'command')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { Checkbox, CopyWell } from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap, StoreModuleMap } from 'client/util/Constants';
import { capitalize } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import InputValidator from 'components/FormValidation/InputValidator.vue';
import Pill from 'components/Buttons/Pill.vue';
import commandTypes from 'client/Commands/constants/CommandTypes';

const commandTemplateModel = StoreModelMap[ItemTypeConsts.commandTemplate];
const commandPlaceholder = {
  [commandTypes.linux]: '#!/bin/bash',
  [commandTypes.mac]: '#!/bin/bash',
  [commandTypes.windows]: 'C:\\',
};
const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];

export default {
  name: 'CommandTemplateDetails',

  inject: ['$validator'],

  components: {
    Checkbox,
    CopyWell,
    InputValidator,
    Pill,
  },

  data: () => ({
    capitalize,
    commandPlaceholder,
    commandTypeOptions: [commandTypes.linux, commandTypes.windows, commandTypes.mac],
    commandTypes,
  }),

  computed: {
    ...mapGetters(commandTemplateModel, [
      'isItemBeingUpdated',
    ]),
    ...mapState(commandTemplateModel, [
      'item',
    ]),
  },
  methods: {
    ...mapActions(commandTemplateModel, ['setItemField']),
    ...mapActions(systemUserCollection, {
      fetchAllUsers: 'fetchAll',
    }),

    handleFieldChange(value, key) {
      this.setItemField({ key, value });
    },
  },
};
</script>

  <style module>
  @import '../../css/flex.css';
  @import "../../components/FormValidation/css/formFields.css";
  @import '../../css/sections.css';

  .inputRowCentered { align-items: center; }

  .commandTypePillContainer { margin: 1px 0 15px; }

  .commandTextarea {
    font-family: var(--jc-font-monospace);
  }

  .copyWell {
    width: 100%;
  }

  /* Require "!important" to overwrite the default component styles because
    it has several selectors that weigh more than the class.

    Overrides https://github.com/TheJumpCloud/jumpcloud-ui-components/blob/master/src/styles/inputs.css#L39
  */
  .copyWell > span {
    font-size: 1rem !important;
    font-weight: 700 !important;
  }

  /* Require "!important" to overwrite the default component styles because
    it has several selectors that weigh more than the class.

    Overrides https://github.com/TheJumpCloud/jumpcloud-ui-components/blob/master/src/components/Inputs/CopyWell/CopyWell.vue#L271
  */
  .copyWell textarea {
    min-height: 5em !important;
  }

  </style>
